module.exports = __webpack_public_path__ + "img/ranking3.f9942e30.png";